import { Controller } from "@hotwired/stimulus";
import { clearMessage, showMessage } from "./client_side_validations_controller";

// Connects to data-controller="group-form"
export default class extends Controller {
  static targets = ["role"];

  validate(event) {
    const valid = this.roleTargets
      .map((role) => this.validateRole(role))
      .every(Boolean);
    if (valid) return;

    event.preventDefault();
    this.element
      .querySelector(".csv-message[data-for^='group_role_']")
      .scrollIntoView({ block: "center" });
  }

  revalidate() {
    this.roleTargets
      .filter((role) => role.dataset.validated)
      .forEach((role) => this.validateRole(role));
  }

  validateRole(role) {
    role.dataset.validated = "true";
    const key = `group_role_${role.dataset.role}`;
    const valid = [...role.querySelectorAll("select[name$='[member_id]']")]
      .filter((select) => !this.removed(select))
      .some((select) => select.value);

    if (valid) clearMessage(this.element, key);
    else
      showMessage(
        this.element,
        key,
        `Select at least one ${role.dataset.role}`,
        role,
      );
    return valid;
  }

  removed(select) {
    const row = select.closest("tr");
    return row.querySelector("input[name$='[_destroy]']")?.value === "1";
  }
}
